import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";
import { Input } from "app/components/ui/input";
import { calculateLoanDefaults } from "~/lib/calculateLoanDefaults";

interface DefaultingLoansCardProps {
  loans: any[];
}

export function DefaultingLoansCard({ loans }: DefaultingLoansCardProps) {
  const [daysFromNow, setDaysFromNow] = useState(5);

  const { count, value } = calculateLoanDefaults(loans, daysFromNow);

  const formatUSD = (value: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          In{" "}
          <Input
            type="number"
            min="1"
            max="365"
            value={daysFromNow}
            onChange={(e) => setDaysFromNow(parseInt(e.target.value) || 5)}
            className="w-16 h-6 text-sm"
          />{" "}
          days,
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{formatUSD(value)}</div>
        <p className="text-xs text-muted-foreground">
          {count} loan{count !== 1 ? "s" : ""} will default
        </p>
      </CardContent>
    </Card>
  );
} 